<section aria-labelledby="position-share-list-heading">
	<h3 id="position-share-list-heading">{{ 'base.field.positionShares' | transloco }}</h3>

	@if (totalPositionShares() > 0) {
		<table mat-table [dataSource]="positionShares()" class="mat-elevation-z2">
			<!-- Share Column-->
			<ng-container matColumnDef="share">
				<th mat-header-cell *matHeaderCellDef>{{ 'base.field.positionShare' | transloco }}</th>
				<td mat-cell *matCellDef="let share">{{ share.share }}</td>
			</ng-container>

			<!-- Start Column -->
			<ng-container matColumnDef="start">
				<th mat-header-cell *matHeaderCellDef>{{ 'base.field.start' | transloco }}</th>
				<td mat-cell *matCellDef="let share">{{ share.start | date: dateDisplayFormat }}</td>
			</ng-container>

			<!-- End Column -->
			<ng-container matColumnDef="end">
				<th mat-header-cell *matHeaderCellDef>{{ 'base.field.end' | transloco }}</th>
				<td mat-cell *matCellDef="let share">
					{{ isValidDate(share.end) ? (share.end | date: dateDisplayFormat) : '-' }}
				</td>
			</ng-container>

			@if (canEditPositionShares()) {
				<!-- Actions Column -->
				<ng-container matColumnDef="actions">
					<th mat-header-cell *matHeaderCellDef>{{ 'base.field.actions' | transloco }}</th>
					<td mat-cell *matCellDef="let share">
						<button
							matIconButton
							[title]="'user.table.trigger_edit' | transloco"
							(click)="editShare.emit(share)"
							[disabled]="loading()"
						>
							<mat-icon>edit</mat-icon>
						</button>
					</td>
				</ng-container>
			}

			<tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
			<tr mat-row [class]="!row.isActive ? 'inactive' : ''" *matRowDef="let row; columns: displayedColumns()"></tr>
		</table>

		<lvr-paginator
			[length]="totalPositionShares()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="true"
			[hidePageSize]="false"
			[disabled]="loading()"
			preferenceKey="position-share-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	} @else {
		<div class="no-position-shares">
			<p>{{ 'user.position_share.no_position_shares' | transloco }}</p>
		</div>
	}
</section>
